/**
 * Detect product photos that are essentially white-background studio shots
 * and mark them so CSS can fade the white into the theme ivory/sand.
 */
(function () {
  var SAMPLE = 6;
  var WHITE_MIN = 242;
  var WHITE_MAX_DELTA = 18;

  function isNearWhite(data, i) {
    var r = data[i];
    var g = data[i + 1];
    var b = data[i + 2];
    var a = data[i + 3];
    if (a < 12) return true;
    if (r < WHITE_MIN || g < WHITE_MIN || b < WHITE_MIN) return false;
    return Math.max(r, g, b) - Math.min(r, g, b) <= WHITE_MAX_DELTA;
  }

  function sampleCorners(ctx, w, h) {
    var points = [
      [2, 2],
      [w - SAMPLE - 2, 2],
      [2, h - SAMPLE - 2],
      [w - SAMPLE - 2, h - SAMPLE - 2],
      [Math.floor(w / 2) - Math.floor(SAMPLE / 2), 2],
      [Math.floor(w / 2) - Math.floor(SAMPLE / 2), h - SAMPLE - 2]
    ];
    var whiteHits = 0;
    for (var p = 0; p < points.length; p += 1) {
      var x = Math.max(0, Math.min(w - SAMPLE, points[p][0]));
      var y = Math.max(0, Math.min(h - SAMPLE, points[p][1]));
      var data = ctx.getImageData(x, y, SAMPLE, SAMPLE).data;
      var cellWhite = 0;
      var cells = SAMPLE * SAMPLE;
      for (var i = 0; i < data.length; i += 4) {
        if (isNearWhite(data, i)) cellWhite += 1;
      }
      if (cellWhite / cells >= 0.78) whiteHits += 1;
    }
    return whiteHits >= 4;
  }

  function markWhiteBg(img) {
    if (!img || img.dataset.whiteBgChecked === 'true') return;
    img.dataset.whiteBgChecked = 'true';

    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.decoding = 'async';

    probe.onload = function () {
      try {
        var w = Math.min(probe.naturalWidth || probe.width, 160);
        var h = Math.min(probe.naturalHeight || probe.height, 160);
        if (w < 8 || h < 8) return;
        var canvas = document.createElement('canvas');
        canvas.width = w;
        canvas.height = h;
        var ctx = canvas.getContext('2d', { willReadFrequently: true });
        if (!ctx) return;
        ctx.drawImage(probe, 0, 0, w, h);
        if (!sampleCorners(ctx, w, h)) return;

        img.classList.add('is-white-bg');
        var host =
          img.closest('.product-card__media') ||
          img.closest('.product-gallery__slide') ||
          img.closest('.product-gallery__thumb') ||
          img.closest('.product-gallery__viewport') ||
          img.closest('.ff-how-we-use__rec-media') ||
          img.closest('.collection-tile') ||
          img.closest('.ff-cart-line__image') ||
          img.closest('.ff-cart-addon__media') ||
          img.closest('.ff-cart-drawer__image') ||
          img.closest('.ff-cart-drawer__rec') ||
          img.closest('.ff-variant-picker__swatch') ||
          img.closest('.ff-wish__item') ||
          img.closest('.ff-passport__cat-bed') ||
          img.parentElement;
        if (host && host !== img) host.classList.add('is-white-bg');
      } catch (err) {
        /* Cross-origin or decode failures — leave image unchanged */
      }
    };

    probe.onerror = function () {};
    var src = img.currentSrc || img.src;
    if (!src) return;
    probe.src = src;
  }

  var IMAGE_SELECTOR = 'img.js-white-bg-check, .product-card__media img, .product-gallery__image, .product-gallery__thumb-image, .collection-tile > img, .ff-cart-drawer__image img, .ff-cart-drawer__rec img, .ff-cart-line__image img, .ff-cart-addon__media img, .ff-wish__item img, .ff-variant-picker__swatch-image, .ff-passport__cat-bed img';

  function scan(root) {
    var scope = root || document;
    var images = [];
    if (scope.matches && scope.matches(IMAGE_SELECTOR)) images.push(scope);
    if (scope.querySelectorAll) {
      scope.querySelectorAll(IMAGE_SELECTOR).forEach(function (img) {
        images.push(img);
      });
    }
    images.forEach(function (img) {
      if (img.dataset.whiteBgChecked === 'true') return;
      if (img.complete && img.naturalWidth > 0) {
        markWhiteBg(img);
      } else {
        img.addEventListener('load', function onLoad() {
          img.removeEventListener('load', onLoad);
          markWhiteBg(img);
        });
      }
    });
  }

  function observe() {
    if (!window.MutationObserver || !document.body) return;
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i += 1) {
        var nodes = mutations[i].addedNodes;
        for (var n = 0; n < nodes.length; n += 1) {
          var node = nodes[n];
          if (!node || node.nodeType !== 1) continue;
          scan(node);
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function start() {
    scan(document);
    observe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });
})();
